import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper);

import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
Vue.use(VideoPlayer)

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  //完全显示的时候加载
  preLoad: 1,
  //失败时显示的图片
  error: require('./assets/img/error.png'),
  //加载时显示的GIF图
  loading: require('./assets/img/loading.gif'),
  //尝试加载几次
  attempt: 1
});

Vue.config.productionTip = false

//设置超时时间
axios.defaults.timeout = 5000
//设置api地址
//全局定义axios
axios.defaults.baseURL = 'http://shkjgw.shkjem.com/api/'
Vue.prototype.$http = axios

// 图片服务器地址
Vue.prototype.imgserver = 'http://shkjgw.shkjem.com/'

//首页经典案例
Vue.prototype.$caseList=[{
  Content:`远程现场视频教学系统是东太科技为响应浙江建设职业技术学院教学领域的需求而开发的创新性产品。
  该系统不仅极大地便利了老师和学生，无论是在线上还是线下，都能够通过该系统正常进行教学和学习，真正实现了教育资源的无缝连接和高效利用。
  首先，它不仅提高了教育的灵活性和适应性，跨越时间和空间，有效解决了天气不好或疫情等突发情况导致的停课问题；
  其次，它还实现了个性化、因材施教的高效教学方式，提供定制化的教学内容和进度，能够更好地激发学生的学习兴趣和潜力。
  此外，该系统还突破了传统“面授”教学的局限，为求知者提供了时间分散、自由安排学习、资源共享、地域广阔、交互式的学习创新方式。
  这种交互式学习方式能够增强学生的参与感和归属感，提高学习的趣味性和效果。`,
  ContentHtml:`<p>远程现场视频教学系统是东太科技为响应浙江建设职业技术学院教学领域的需求而开发的创新性产品。</p>
  <p>该系统不仅极大地便利了老师和学生，无论是在线上还是线下，都能够通过该系统正常进行教学和学习，真正实现了教育资源的无缝连接和高效利用。</p>
  <p>首先，它不仅提高了教育的灵活性和适应性，跨越时间和空间，有效解决了天气不好或疫情等突发情况导致的停课问题；</p>
  <p>其次，它还实现了个性化、因材施教的高效教学方式，提供定制化的教学内容和进度，能够更好地激发学生的学习兴趣和潜力。</p>
  <p>此外，该系统还突破了传统“面授”教学的局限，为求知者提供了时间分散、自由安排学习、资源共享、地域广阔、交互式的学习创新方式。</p>
  <p>这种交互式学习方式能够增强学生的参与感和归属感，提高学习的趣味性和效果。</p>`,

  // CreateTime:'2023-06-05 15:15:20',
  Del:null,
  Id:1,
  Img: "https://www.eastsun.net/eastsunImg/5.png",
  Title: "远程现场视频教学系统"
},
  {
    Content:`东太建设监管平台是一款专为建筑行业打造的综合性项目管理工具。
    该平台集成了众多先进的功能，旨在帮助项目管理者、业主、承包商及相关利益方实现对建设项目的全面、高效、全生命周期的实时监管。
    第一，项目进度查询，用户可实现对项目群的宏观掌控。
    第二，项目详情展示，用户可查看项目的详细资料，为项目决策提供有力支持。
    第三，实时现场监控，用户可通过平台实时查看项目施工现场的实际情况，确保项目的顺利进行。
    第四，项目验收与结算，用户可实时查看项目的验收结算情况，确保项目信息沟通及时、顺畅、准确。
    第五，支付管理与统计分析，用户可根据需要对项目数据深入挖掘和分析，为项目决策提供有力支持。
    第六，操作记录与安全保障，平台记录了所有用户的操作行为，确保项目数据的完整性和可追溯性。
    同时，平台还采用了先进的安全防护措施，保障用户数据的安全性和隐私性。
    总之，东太建设监管平台凭借其全面的功能、高效的操作和安全的保障，可以有效助力您的项目成功实现。`,
    ContentHtml:`<p>东太建设监管平台是一款专为建筑行业打造的综合性项目管理工具。</p>
    <p> 该平台集成了众多先进的功能，旨在帮助项目管理者、业主、承包商及相关利益方实现对建设项目的全面、高效、全生命周期的实时监管。</p>
    <p>第一，项目进度查询，用户可实现对项目群的宏观掌控。</p>
    <p>第二，项目详情展示，用户可查看项目的详细资料，为项目决策提供有力支持。</p>
    <p>第三，实时现场监控，用户可通过平台实时查看项目施工现场的实际情况，确保项目的顺利进行。</p>
    <p>第四，项目验收与结算，用户可实时查看项目的验收结算情况，确保项目信息沟通及时、顺畅、准确。</p>
    <p>第五，支付管理与统计分析，用户可根据需要对项目数据深入挖掘和分析，为项目决策提供有力支持。</p>
    <p>第六，操作记录与安全保障，平台记录了所有用户的操作行为，确保项目数据的完整性和可追溯性。</p>
    <p>同时，平台还采用了先进的安全防护措施，保障用户数据的安全性和隐私性。</p>
    <p>总之，东太建设监管平台凭借其全面的功能、高效的操作和安全的保障，可以有效助力您的项目成功实现。</p>`,
    // CreateTime:'2023-07-09 14:09:45',
    Del:null,
    Id:2,
    Img: "https://www.eastsun.net/eastsunImg/4.png",
    Title: "东太建设监管平台"
  },

  {
    Content:`水环境治理监测智慧物联管控平台是一款具备实时数据采集、水质指标分析、水质特变指标反控智慧物联选择不同的智能化方案自动参与河道治理
    等强大功能的治理与监测平台。主要具有以下核心功能：
    一、河道信息管理。实现了测点和河道的绑定，为河道管理提供了全面的信息化支持。
    二、视频监管。用户可以同时对多个河段进行监控，灵活调整监控视角，满足不同的监控需求。
    三、巡检签到。巡检人员只需通过手机端软件进行签到，还确保了巡检数据的真实性和完整性。
    四、水质测点模块。平台通过绑定设备和河道，以折线图展示历史数据，为水质变化提供直观的依据。
    五、智慧物联模块。平台提供了对治理设备边缘网关进行操控的功能，实现对设备正常运行的全面掌控。
    六、巡河记录模块。巡检员可填写日志，管理员处理异常巡河记录后可上报到河长，形成闭环处理机制。
    以上功能不仅提高了问题处理效率，提升区域水环境水质生态指数，还有助于实现区域水环境持续改进。`,
    ContentHtml:`<p>水环境治理监测智慧物联管控平台是一款具备实时数据采集、水质指标分析、水质特变指标反控智慧物联选择不同的智能化方案自动参与河道治理
    等强大功能的治理与监测平台。主要具有以下核心功能：</p>
    <p>一、河道信息管理。实现了测点和河道的绑定，为河道管理提供了全面的信息化支持。</p>
    <p>二、视频监管。用户可以同时对多个河段进行监控，灵活调整监控视角，满足不同的监控需求。</p>
    <p>三、巡检签到。巡检人员只需通过手机端软件进行签到，还确保了巡检数据的真实性和完整性。</p>
    <p>四、水质测点模块。平台通过绑定设备和河道，以折线图展示历史数据，为水质变化提供直观的依据。</p>
    <p>五、智慧物联模块。平台提供了对治理设备边缘网关进行操控的功能，实现对设备正常运行的全面掌控。</p>
    <p>六、巡河记录模块。巡检员可填写日志，管理员处理异常巡河记录后可上报到河长，形成闭环处理机制。</p>
    <p>以上功能不仅提高了问题处理效率，提升区域水环境水质生态指数，还有助于实现区域水环境持续改进。</p>`,
     // CreateTime:'2023-07-20 16:10:23',
     Del:null,
    Id:3,
    Img: "https://www.eastsun.net/eastsunImg/daping.png",
    Title: "治理监测平台"
  },

  {
    Content:`东太空中课堂平台，是公司专为现代远程教育精心打造的一站式解决方案，具有强大的功能、便捷的操作和优质的用户体验。
    首先，平台支持监控设备的远程安装、调试与录像存储，确保实时、高清的教学现场传输。
    其次，平台内置的视频精品课件系统，允许教师上传、分享自己优质课件，为学生提供丰富的学习材料。
    此外，平台还提供了稳定、安全的云服务，确保课件的实时在线播放，为师生提供流畅的学习体验。
    更重要的是，平台支持校内外网络访问，打破了传统教学的地域限制，让学生能随时随地接入平台学习。
    总之，东太空中课堂平台该平台不仅满足了校方对于无线远程现场施工教学监控的需求，更提供了丰富的视频精品课件资源，实现了教学资源的全面整合与高效利用。`,
    ContentHtml:`<p>东太空中课堂平台，是公司专为现代远程教育精心打造的一站式解决方案，具有强大的功能、便捷的操作和优质的用户体验。</p>
                 <p>首先，平台支持监控设备的远程安装、调试与录像存储，确保实时、高清的教学现场传输。</p>
                 <p>其次，平台内置的视频精品课件系统，允许教师上传、分享自己优质课件，为学生提供丰富的学习材料。</p>
    <p>此外，平台还提供了稳定、安全的云服务，确保课件的实时在线播放，为师生提供流畅的学习体验。</p>
    <p>更重要的是，平台支持校内外网络访问，打破了传统教学的地域限制，让学生能随时随地接入平台学习。</p>
    <p>总之，东太空中课堂平台该平台不仅满足了校方对于无线远程现场施工教学监控的需求，更提供了丰富的视频精品课件资源，实现了教学资源的全面整合与高效利用。</p>`,
    // CreateTime:'2023-07-21 14:16:18',
    Del:null,
    Id:4,
    Img: "https://www.eastsun.net/eastsunImg/kongzhongimg.png",
    Title: "空中课堂平台"
  },

  {
    Content: `农业智慧物联促生长管控平台, 是基于物联网技术旨在提高农业生产智慧管理 高效生产和可持续发展系统。
    平台通过实时监测农作物生长环境、畜禽和水产养殖等关键指标，为农业生产提供精准、及时的数据支持，实现农业决策的智慧化。
    平台的核心优势在于其强大的数据监测和分析能力，智慧控制植物所需要的水、气、肥、光照等环境因素。
    通过部署在农田、养殖场等关键区域的传感器，系统能实时收集气泡水、气、肥、光照、湿度、温度等数据，并通过云计算和大数据技术深度分析，
    为农业生产提供科学、合理的指导建议。
    一方面，在农业种植领域，平台可根据不同作物的生长需求和特点，为其创造更加适宜的生长环境。
    另一方面，在畜禽和水产养殖领域，该平台同样发挥着重要作用。
    通过实时监测养殖环境的各项指标，系统能够及时发现养殖过程中出现的问题，如水质污染、疾病传播等，并给出相应的解决方案。
    总之，东太农业智慧物联促生长管控平台以其精准、高效、可持续的特点，我们可实现农业生产的智能化、精准化和绿色化，为农民创造更多的经济价值和社会价值。`,
    ContentHtml:`<p>农业智慧物联促生长管控平台, 是基于物联网技术旨在提高农业生产智慧管理 高效生产和可持续发展系统。</p>
    <p>平台通过实时监测农作物生长环境、畜禽和水产养殖等关键指标，为农业生产提供精准、及时的数据支持，实现农业决策的智慧化。</p>
    <p>平台的核心优势在于其强大的数据监测和分析能力，智慧控制植物所需要的水、气、肥、光照等环境因素。</p>
    <p>通过部署在农田、养殖场等关键区域的传感器，系统能实时收集气泡水、气、肥、光照、湿度、温度等数据，并通过云计算和大数据技术深度分析，
    为农业生产提供科学、合理的指导建议。</p>
    <p>一方面，在农业种植领域，平台可根据不同作物的生长需求和特点，为其创造更加适宜的生长环境。</p>
    <p>另一方面，在畜禽和水产养殖领域，该平台同样发挥着重要作用。</p>
    <p>通过实时监测养殖环境的各项指标，系统能够及时发现养殖过程中出现的问题，如水质污染、疾病传播等，并给出相应的解决方案。</p>
    <p>总之，东太农业智慧物联促生长管控平台以其精准、高效、可持续的特点，我们可实现农业生产的智能化、精准化和绿色化，为农民创造更多的经济价值和社会价值。</p>`,
    // CreateTime:'2023-08-10 16:17:10',
    Del:null,
    Id:5,
    Img: "https://www.eastsun.net/eastsunImg/nongye.png",
    Title: "农业智慧物联促生长管控平台"
  },


  {
    Content:`东太趣学吧软件是一款功能丰富、操作便捷、互动性强的教学辅助软件。
    这款软件结合了先进的教育理念和前沿的科技手段，以满足国家教育信息化建设的需求为核心，旨在打造线上线下相融合的寓教于乐学习平台。
    首先，软件提供了丰富的学习资源，包括视频课程、互动练习、在线测试等，内容涵盖各个学科领域，满足不同学生的需求。
    其次，软件采用先进的教学技术，如智能推荐、个性化学习路径等，能够根据学生学习情况和兴趣偏好，提供定制化学习方案。
    此外，软件还具备社交互动的功能，学生们可以在软件内与同学交流学习心得，向老师请教学习问题，营造积极向上的学习氛围。
    在使用东太趣学吧软件的过程中，教师和学生都能获得诸多便利。教师可以通过软件轻松管理课程、发布作业、查看学生学习进度等，提高教学效率。同时，学生则可以根据自己的需求随时随地进行学习，利用碎片化时间提升自己的学习成绩。
    总的来说，东太趣学吧软件能够满足教育信息化建设的需求，为学生和教师带来全新的学习体验。无论是线上还是线下，东太趣学吧都能让学习变得更加有趣和高效。`,
    ContentHtml:`<p>东太趣学吧软件是一款功能丰富、操作便捷、互动性强的教学辅助软件。</p>
    <p> 这款软件结合了先进的教育理念和前沿的科技手段，以满足国家教育信息化建设的需求为核心，旨在打造线上线下相融合的寓教于乐学习平台。</p>
    <p> 首先，软件提供了丰富的学习资源，包括视频课程、互动练习、在线测试等，内容涵盖各个学科领域，满足不同学生的需求。</p>
    <p> 其次，软件采用先进的教学技术，如智能推荐、个性化学习路径等，能够根据学生学习情况和兴趣偏好，提供定制化学习方案。</p>
    <p> 此外，软件还具备社交互动的功能，学生们可以在软件内与同学交流学习心得，向老师请教学习问题，营造积极向上的学习氛围。</p>
    <p> 在使用东太趣学吧软件的过程中，教师和学生都能获得诸多便利。教师可以通过软件轻松管理课程、发布作业、查看学生学习进度等，提高教学效率。同时，学生则可以根据自己的需求随时随地进行学习，利用碎片化时间提升自己的学习成绩。</p>
    <p> 总的来说，东太趣学吧软件能够满足教育信息化建设的需求，为学生和教师带来全新的学习体验。无论是线上还是线下，东太趣学吧都能让学习变得更加有趣和高效。</p>`,
    // CreateTime:'2023-08-10 16:17:10',
    Del:null,
    Id:6,
    Img: "https://www.eastsun.net/eastsunImg/8.png",
    Title: "趣学吧"
  }
  ]
//首页新闻
Vue.prototype.$newsList=[
  // {
  //   Content:'根据省、市相关评价标准，现将拟评定为2023年度杭州市“美丽河湖”的26条（段、个）河湖予以公示，接受社会公众监督。现就有关事情通告如下：\n' +
  //       '\n' +
  //       '1.反映问题的方式：在公示期限内，任何单位和个人均可通过来信、来电、来访等形式，向杭州市林业水利局、城市管理局、河长办反映公示对象存在的问题。以单位名义反映问题的应加盖公章。以个人名义反映问题的提倡署报本人真实姓名。\n' +
  //       '\n' +
  //       '2.要求：反映问题要坚持实事求是的原则，反对借机诽谤诬告。\n' +
  //       '\n' +
  //       '3.公示时间：从11月28日起到12月4日止。\n' +
  //       '\n' +
  //       '4.公示联系部门和受理方式。联系部门：杭州市林业水利局，杭州市德胜路353号，邮编：310014；杭州市城市管理局，杭州市体育场路231号，邮编：310006；杭州市河长办，德胜路353号，邮编310014。\n' +
  //       '\n' +
  //       '联系电话:0571-88080548（市林水局），0571-85866219（市城管局），0571-88394776（市河长办）。\n' +
  //       '\n' +
  //       '杭州市林业水利局\n' +
  //       '\n' +
  //       '杭州市城市管理局\n' +
  //       '\n' +
  //       '美丽杭州建设领导小组“五水共治”河长制办公室',
  //   CreateTime:'2023- 11- 28 11: 15',
  //   Id:1,
  //   Img: "/fengjing2.png",
  //   Title: "2023年度杭州市“美丽河湖”评定结果的公示",
  //   newsType:2
  // },
  {
    Content:'　中新社杭州11月14日电 (钱晨菲)浙江省生态环境厅14日发布钱塘江水生态环境健康评价成果，钱塘江水系水生态健康总体优良。' +
        '　　钱塘江是浙江省的母亲河。本次评价共涉及钱塘江水系干流和主要支流长度1130公里。评价结果显示，在41个河段中，评价为优良的河段占比为97.6%。从评价指标看 ，其基本生态流量满足程度、水质优劣、水环境功能区达标率及公众满意度等方面较好 ，在纵向连通性、底栖动物群落组成和富营养化硅藻指数等方面仍有提升改善的空间。\n' +
        '　　浙江省生态环境厅党组书记、厅长郎文荣介绍说，在水环境质量方面，2022年，钱塘江水系总体水质状况为优，60个省控以上断面水质均达到或优于Ⅲ类 ，其中Ⅰ类13.4%、Ⅱ类63.3%、Ⅲ类23.3% ，全部满足水环境功能区目标水质要求，达标率为100% 。',
    ContentHtml:`<p>中新社杭州11月14日电 (钱晨菲)浙江省生态环境厅14日发布钱塘江水生态环境健康评价成果，钱塘江水系水生态健康总体优良。</p>
    <p> 钱塘江是浙江省的母亲河。本次评价共涉及钱塘江水系干流和主要支流长度1130公里。评价结果显示，在41个河段中，评价为优良的河段占比为97.6%。从评价指标看 ，其基本生态流量满足程度、水质优劣、水环境功能区达标率及公众满意度等方面较好 ，在纵向连通性、底栖动物群落组成和富营养化硅藻指数等方面仍有提升改善的空间。</p>
    <p> 浙江省生态环境厅党组书记、厅长郎文荣介绍说，在水环境质量方面，2022年，钱塘江水系总体水质状况为优，60个省控以上断面水质均达到或优于Ⅲ类 ，其中Ⅰ类13.4%、Ⅱ类63.3%、Ⅲ类23.3% ，全部满足水环境功能区目标水质要求，达标率为100%。</p>`,
    // CreateTime:'2023-08-10 16:17:10',
    CreateTime:'2023-11-14 20:44:19',
    Id:1,
    Img: "https://www.eastsun.net/eastsunImg/qiantangjiang.png",
    Title: "钱塘江水生态环境最新评价发布 优良河段占比97.6%",
    newsType:1
  },
  {
    Content:'9月20日至21日,根据《浙江省水资源监测中心关于对丽水分中心开展内部审核和水质监测安全检查的通知 》安排，浙江省水文局水质部副主任卢卫带队对浙江省水资源监测中心丽水分中心开展内部审核和水质安全检查工作。' +
        '\n' +
        '内审组严格按照《检验检测机构资质认定能力评价检验检测机构通用要求》、管理体系文件和水质监测安全管理等要求,通过现场查看、询问及查阅档案等方式开展全面检查。对实验室的技术能力（包括“设施和环境”、“仪器设备和标准物质”、 “检验方法”、“证书和报告”等）和管理能力（包括“组织和管理”、“质量体系”、“人员”、 “记录”等要素）进行了评审和考核。审核组充分肯定了丽水分中心在水资源监测、实验室管理、体系运行等方面取得的成绩,一致认为丽水分中心组织机构健全，管理体系运行有效,能够遵守国家法律法规。但同时也存在8项不符合项,要求应于10个工作日内完成整改工作。\n' +
        '\n' +
        '丽水分中心对所有问题点进行汇总   ,查找管理体系中存在的薄弱环节,按照内审组提出的整改建议及时整改,进一步推动实验室的高质量发展 ,提升丽水分中心的水资源监测水平  ,为落实最严格水资源管理、开展幸福河湖   建设等提供更准确有效的决策依据。',
    ContentHtml:`<p>9月20日至21日,根据《浙江省水资源监测中心关于对丽水分中心开展内部审核和水质监测安全检查的通知 》安排，浙江省水文局水质部副主任卢卫带队对浙江省水资源监测中心丽水分中心开展内部审核和水质安全检查工作。</p>
    <p> 内审组严格按照《检验检测机构资质认定能力评价检验检测机构通用要求》、管理体系文件和水质监测安全管理等要求,通过现场查看、询问及查阅档案等方式开展全面检查。</p>
    <p>对实验室的技术能力（包括“设施和环境”、“仪器设备和标准物质”、 “检验方法”、“证书和报告”等）和管理能力（包括“组织和管理”、“质量体系”、“人员”、 “记录”等要素）进行了评审和考核。</p>
    <p> 审核组充分肯定了丽水分中心在水资源监测、实验室管理、体系运行等方面取得的成绩,一致认为丽水分中心组织机构健全，管理体系运行有效,能够遵守国家法律法规。但同时也存在8项不符合项,要求应于10个工作日内完成整改工作。</p>
    <p> 丽水分中心对所有问题点进行汇总   ,查找管理体系中存在的薄弱环节,按照内审组提出的整改建议及时整改,进一步推动实验室的高质量发展 ,提升丽水分中心的水资源监测水平  ,为落实最严格水资源管理、开展幸福河湖   建设等提供更准确有效的决策依据。</p>`,
    CreateTime:'2023-09-22 16:52',
    Id:2,
    Img: "https://www.eastsun.net/eastsunImg/lishui.png",
    Title: "浙江省水资源监测中心丽水分中心顺利通过2023年度内部审核和水质监测安全检查",
    newsType:2
  },
]
//走进科建 公司荣誉数据
Vue.prototype.$honorList=[
  {
    CreateTime: "2021-03-26T13:25:19.433",
    Id: 101,
    Img: "https://www.eastsun.net/eastsunImg/zhengshu1.jpg",

  },
  {
    CreateTime: "2021-03-26T13:25:19.433",
    Id: 102,
    Img: "https://www.eastsun.net/eastsunImg/zhengshu2.jpg",

  },
  {
    CreateTime: "2021-03-26T13:25:19.433",
    Id: 103,
    Img: "https://www.eastsun.net/eastsunImg/zhengshu3.jpg",

  },
  {
    CreateTime: "2021-03-26T13:25:19.433",
    Id: 104,
    Img: "https://www.eastsun.net/eastsunImg/zhengshu4.jpg",

  },
  {
    CreateTime: "2021-03-26T13:25:19.433",
    Id: 105,
    Img: "https://www.eastsun.net/eastsunImg/zhengshu5.jpg",

  },
  {
    CreateTime: "2021-03-26T13:25:19.433",
    Id: 106,
    Img: "https://www.eastsun.net/eastsunImg/zhengshu6.jpg",

  },
  {
    CreateTime: "2021-03-26T13:25:19.433",
    Id: 108,
    Img: "https://www.eastsun.net/eastsunImg/zhengshu7.jpg",
  },
  {
    CreateTime: "2021-03-26T13:25:19.433",
    Id: 107,
    Img: "https://www.eastsun.net/eastsunImg/zhengshu8.jpg",
  },
],
//走进科建 发展历程数据
Vue.prototype.$courseList=[
  {
    "Id": 10,
    "Year": "2002年",
    "Content": "公司成立"
  },

  {
    "Id": 11,
    "Year": "2003年",
    "Content": "首次取得信息系统集成及服务资质认证叁级;  首次获得万泰认证，全面导入ISO9001（2000版）质量管理体系;  首次被杭州市企业信用评定委员会授予AA级信用企业称号;"
  },

  {
    "Id": 12,
    "Year": "2004年-2009年",
    "Content": "与知名供应商建立了长期的战略合作关系，包括：\n" +
        "Cisco、NORTEL、AVAYA、Fujitsu\n" +
        "IBM、HP、SUN、Maxtor (NAS)\n" +
        "美国西蒙、美国诺顿公司、ZDSOFT\n" +
        "神州数码、华为、曙光、紫光\n" +
        "绿盟、360、上海华依、方正……"
  },
  {
    "Id": 14,
    "Year": "2010年-2015年",
    "Content": "东太智慧工地软件成型;\n" +
        "东太教学互动软件成型;\n" +
        "东太RFID资源管理系统成型;\n" +
        "东太视频切片管理系统成型;\n" +
        "东太违规行为管理系统成型;"
  },
  {
    "Id": 18,
    "Year": "2016年-2018年",
    "Content": "自主学习教育平台软件成型;\n" +
        "智慧种植管理平台软件成型;\n" +
        "东太建设工程监管平台落地;\n" +
        "“一张图”现场实时辅助决策软件成型;"
  },
  {
    "Id": 18,
    "Year": "2019年-2021年",
    "Content": "空中课堂平台软件成型;\n" +
        "空中课堂APP联调成功;\n" +
        "地质灾害监测管理软件成型;\n" +
        "智慧教育教学管理平台软件成型;\n" +
        "美丽乡村智慧管理服务平台软件成型;\n" +
        "公司获得“国家级高新企业”认定证书;"
  },
  {
    "Id": 19,
    "Year": "2022年-2024年",
    "Content": "数字化智慧种植管理系统成型;\n" +
        "水利防洪工程数据库分析系统成型;\n" +
        "乡村振兴农业互动远程培训系统成型;\n" +
        "乡村振兴技术改造项目管理系统成型;\n" +
        "城投综合立体化智能监管平台系统成型;\n" +
        "水环境智慧监管与调控平台V1.0落地;\n" +
        "水环境治理监测智慧物联管控平台V2.0成型;\n" +
        "水环境治理监测APPV2.0联调成功;"
  },
],
//走进科建 公司荣誉数据
Vue.prototype.$teamItem=[
  {
    "Id": 16,
    "Img": "https://www.eastsun.net/eastsunImg/tuandui10.jpg",
    // "Remark": "",
    "CreateTime": "2019-04-26T16:05:38.187"
  },
  {
    "Id": 11,
    "Img": "https://www.eastsun.net/eastsunImg/tuandui11.jpg",
    // "Remark": "",
    "CreateTime": "2019-04-26T16:05:38.187"
  },

        {
          "Id": 6,
          "Img": "https://www.eastsun.net/eastsunImg/tuandui3.jpg",
          // "Remark": "参加第七届中国（上海）国际技术进出口交易会",
          "CreateTime": "2020-06-05T21:34:36.397"
        },
        {
          "Id": 22,
          "Img": "https://www.eastsun.net/eastsunImg/tuandui4.jpg",
          // "Remark": "",
          "CreateTime": "2019-04-26T16:06:18.193"
        },
        {
          "Id": 21,
          "Img": "https://www.eastsun.net/eastsunImg/tuandui5.jpg",
          // "Remark": "",
          "CreateTime": "2019-04-26T16:06:11.277"
        },
        {
          "Id": 20,
          "Img": "https://www.eastsun.net/eastsunImg/tuandui6.jpg",
          // "Remark": "",
          "CreateTime": "2019-04-26T16:06:03.21"
        },
        {
          "Id": 19,
          "Img": "https://www.eastsun.net/eastsunImg/tuandui7.jpg",
          // "Remark": "",
          "CreateTime": "2019-04-26T16:05:55.947"
        },
        {
          "Id": 17,
          "Img": "https://www.eastsun.net/eastsunImg/tuandui9.jpg",
          // "Remark": "",
          "CreateTime": "2019-04-26T16:05:38.187"
        },
        {
          "Id": 18,
          "Img": "https://www.eastsun.net/eastsunImg/tuandui8.jpg",
          // "Remark": "",
          "CreateTime": "2019-04-26T16:05:47.69"
        },


    ],
    //走进科建 合作伙伴
    Vue.prototype.$partnerImg=[

      {
        "Id": 25,
        "Img": "https://www.eastsun.net/eastsunImg/huoban2.jpg",
        // "Remark": "丰丰qDFc2ewdrs",
        "CreateTime": "2021-08-10T01:59:55.71"
      },
      {
        "Id": 26,
        "Img": "https://www.eastsun.net/eastsunImg/huoban3.jpg",
        // "Remark": "",
        "CreateTime": "2021-08-10T02:00:45.8"
      },
      {
        "Id": 27,
        "Img": "https://www.eastsun.net/eastsunImg/huoban4.jpg",
        // "Remark": "",
        "CreateTime": "2022-12-31T12:06:49.057"
      },
        ],



new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
